import { useQuery } from '@tanstack/react-query';
import { getEventLog } from '../event-log';
import { EventLogFilters } from '../event-log/types';

export function useEventLog(filters: EventLogFilters) {
  return useQuery({
    queryKey: ['eventLog', filters.date, filters.expand],
    queryFn: () => getEventLog(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}